(() => {
  const loadLatestArrivals = () => {
    document.querySelectorAll('[id^="collection-"]').forEach((section) => {
      const heading = section.querySelector('.collection__title');
      if (!heading || !heading.textContent.includes('最新到貨')) return;

      const grid = section.querySelector('.product-grid');
      if (!grid) return;

      const hasRealProducts = grid.querySelector('a[href^="/products/"]');
      const hasPlaceholders = grid.querySelector('.card__heading--placeholder, .placeholder-svg');
      if (hasRealProducts && !hasPlaceholders) return;

      const escapeHtml = (value) =>
        String(value || '').replace(/[&<>"']/g, (char) => ({
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#39;',
        })[char]);

      const formatMoney = (value) => {
        const amount = Number(value || 0);
        return `HK$${amount.toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })} HKD`;
      };

      const productCard = (product, index) => {
        const image = product.images && product.images[0] && product.images[0].src;
        const variant = product.variants && product.variants[0];
        const url = `/products/${product.handle}`;
        const imageHtml = image
          ? `<img src="${escapeHtml(image)}" alt="${escapeHtml(product.title)}" loading="${index > 4 ? 'lazy' : 'eager'}">`
          : '';

        return `
          <li class="grid__item">
            <div class="card-wrapper product-card-wrapper underline-links-hover bgtcg-non-single-card">
              <div class="card card--standard" style="--ratio-percent: 100%;">
                <a class="card__inner color-scheme-2 gradient ratio" href="${escapeHtml(url)}" aria-label="${escapeHtml(product.title)}">
                  <div class="card__media"><div class="media media--transparent">${imageHtml}</div></div>
                </a>
                <div class="card__content">
                  <div class="card__information">
                    <h3 class="card__heading h5"><a href="${escapeHtml(url)}" class="full-unstyled-link">${escapeHtml(product.title)}</a></h3>
                    <div class="card-information">
                      <div class="price"><div class="price__container"><div class="price__regular">
                        <span class="price-item price-item--regular">${variant ? formatMoney(variant.price) : ''}</span>
                      </div></div></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>`;
      };

      fetch('/collections/products/products.json?limit=25')
        .then((response) => (response.ok ? response.json() : null))
        .then((data) => {
          const products = data && data.products ? data.products : [];
          if (!products.length) return;
          grid.innerHTML = products.map(productCard).join('');
        })
        .catch(() => {});
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadLatestArrivals);
  } else {
    loadLatestArrivals();
  }
})();
